export enum UserFileStatus {
  NEW = 'NEW',
  PROCESSING = 'PROCESSING',
  DONE = 'DONE',
  FAILED = 'FAILED',
  EXTERNAL = 'EXTERNAL',
  ARCHIVED = 'ARCHIVED'
}
